(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'FitBuilder',
	};

	var $modal             = $('.modal'),
		$no_add_components = ['air', 'excursion', 'rail', 'transfer'];

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var incrementor;

		// toggle global/custom banner fields
		$('.image-type > .btn-radio').click(function _imageTypeClicked() {
			var data_type = $(this).data('type');

			if (data_type === 'global') {
				// global banner
				$('.global-banner').removeClass('hidden');
				$('.custom-banner').addClass('hidden');
			} else {
				// custom banner
				$('.global-banner').addClass('hidden');
				$('.custom-banner').removeClass('hidden');
			}
		});

		// custom banner
		$('.remove-banner').click(function _removeCustomBanner(e) {
			e.preventDefault();

			$('#fitbuilder-image_name').val('');
			$('#fitbuilder-remove_banner').val('1');
			$('.selected-banner').attr('src', '');

			$('.selected-banner-remove').addClass('hidden');
		});

		$('#fitbuilder-start_date').on('dp.change', function dateChange(e) {
			var start_date     = e.date,
				end_date       = $('#fitbuilder-end_date').data('DateTimePicker'),
				max_components = $('#fitbuilder-number_components option:last-child').val(),
				start_picker,
				end_picker,
				i;

			for (i=1;i<=max_components;i++) {
				start_picker = $('#start-date-' + i).data('DateTimePicker');
				start_picker.date(start_date.format('YYYY-MM-DD'));

				end_picker = $('#start-date-' + i).data('DateTimePicker');
				end_picker.date(start_date.format('YYYY-MM-DD'));
			}

			if (end_date.date() === null || end_date.date().isBefore(start_date) === true) {
				end_date.date(start_date).date(e.date.add(1, 'days'));
			}
		});

		$('.insert-form-link').on('click', function onClick(e)
		{
			var link_url = $(this).data('url'),
			    link_text = $(this).data('text'),
			    editor, // eslint-disable-line no-unused-vars
			    current_content,
			    new_content;

			e.preventDefault();

			editor = Adzuki.Editor('#fitbuilder-overview', {
				init_instance_callback: function onEditorInit(_editor) {
					// get the editor's current content
					current_content = _editor.getContent();

					// append the link
					new_content = current_content + '<p><a href="' + link_url + '" target="_blank">' + link_text + '</a></p>';

					// set the editor to new content
					_editor.setContent(new_content);

					$('#fitbuilder-overview').val(new_content);
				},
				height: 400,
			});
		});

		$('#fitbuilder-number_components').change(function _showHideBoxes() {
			var num = parseFloat($(this).val());

			$('.component-boxes').addClass('hidden');

			$('.component-boxes').each(function _show() {
				if ($(this).data('num') <= num) {
					loadVendorTypeAhead($(this).data('num'));
					loadDestinationTypeAhead($(this).data('num'));
					$(this).removeClass('hidden');
				}
			});
		});

		$('.component-type').change(function _showHideDestination() {
			var index             = parseInt($(this).data('i')) - 1,
				i                 = $(this).data('i'),
				component_type    = $(this).val(),
				hide_vendor_label = '';

			$('.reset-component-vendor[data-i="' + i + '"]').trigger('click');

			switch (component_type) {
				case 'air':
					$('.component-vendor-label[data-i="' + i + '"]').html('Airline');
					$('.fit-builder-destination-container[data-index="' + index + '"]').removeClass('hidden');
					break;
				case 'car':
					$('.component-vendor-label[data-i="' + i + '"]').html('Car Rental Company');
					$('.fit-builder-destination-container[data-index="' + index + '"]').removeClass('hidden');
					break;
				case 'cruise':
					$('.component-vendor-label[data-i="' + i + '"]').html('Cruise Line');
					$('.fit-builder-destination-container[data-index="' + index + '"]').addClass('hidden');
					break;
				case 'excursion':
					$('.component-vendor-label[data-i="' + i + '"]').html('Excursion Company');
					$('.fit-builder-destination-container[data-index="' + index + '"]').addClass('hidden');
					break;
				case 'lodging':
					$('.component-vendor-label[data-i="' + i + '"]').html('Hotel Chain');
					$('.fit-builder-destination-container[data-index="' + index + '"]').removeClass('hidden');
					break;
				case 'package':
					$('.component-vendor-label[data-i="' + i + '"]').html('Package Supplier');
					$('.fit-builder-destination-container[data-index="' + index + '"]').removeClass('hidden');
					break;
				case 'rail':
					$('.component-vendor-label[data-i="' + i + '"]').html('Rail Company');
					$('.fit-builder-destination-container[data-index="' + index + '"]').removeClass('hidden');
					break;
				case 'transfer':
					$('.component-vendor-label[data-i="' + i + '"]').html('Transfer Company');
					$('.fit-builder-destination-container[data-index="' + index + '"]').removeClass('hidden');
					break;
				default:
					// no component type selected, make field label generic, and disable it
					$('.component-vendor-label[data-i="' + i + '"]').html('Vendor');
					$('.component_vendors[data-i="' + num + '"]').prop('disabled', true);
					break;
			}

			// update the "hide vendor" field label based on selected component type
			hide_vendor_label = $('.component-vendor-label[data-i="' + i + '"]').text();

			$('.component-hide-vendor-label[data-i="' + i + '"]').html('Hide ' + hide_vendor_label + ' in Trip Summary');
		});

		$('.opportunity-client-name').change(function _setClient() {
			var client_id   = $('.opportunity-client-id').val(),
			    client_name = $('.opportunity-client-name').val();

			if (client_id === '') {
				// reset the client fields
				$('#fitbuilder-client_id').val('');
				$('#fitbuilder-client_search').val('');
				$('#fitbuilder-client_search').prop('disabled', false);
				$('.reset-client').addClass('hidden');
			} else {
				// set the client fields to the sales opp client
				$('#fitbuilder-client_id').val(client_id);
				$('#fitbuilder-client_search').val(client_name);
				$('#fitbuilder-client_search').prop('disabled', true);
				$('.reset-client').removeClass('hidden');
			}
		});

		$('#fitbuilder-packaged_by').change(function _adjustItemsBasedOnPackager() {
			var $component_type_select;

			switch ($(this).val()) {
				case 'supplier':
					$('.package-provider').removeClass('hidden');
					$('.component-packaged-by').addClass('hidden');

					$('.package-vendor-select').each(function _clearPackageVendorId() {
						$(this).val('');
					});

					// If we changed back to and there is no primary vendor set
					if ($('#fitbuilder-primary_vendor_id').val() === '') {
						Adzuki.Ajax.get('/FitBuilders/componentTypes/')
						.then(function _adjustSelections(response) {
							$('.component-type').each(function _resetcomponentType() {
								$component_type_select = $(this);
								$component_type_select.empty();
								$component_type_select.append($('<option>').text('Please Select').attr('value', 'request'));

								$.each(response, function _iterateTypes(index, element) {
									$component_type_select.append($('<option>').text(element).attr('value', index));
								});
							});
						});
					}

					$('.packaged_by > .btn-default[data-type="supplier"]').removeClass('active');
					$('.packaged_by > .btn-default[data-type="direct"]').addClass('active');
					break;
				case 'direct':
					$('.package-provider').addClass('hidden');
					$('.component-packaged-by').addClass('hidden');

					$('.package-vendor-select').each(function _clearPackageVendorId() {
						$(this).val('');
					});

					$('.packaged_by > .btn-default[data-type="supplier"]').addClass('active');
					$('.packaged_by > .btn-default[data-type="direct"]').removeClass('active');
					break;
				case 'mixed':
					$('.package-provider').addClass('hidden');
					$('.component-packaged-by').removeClass('hidden');
					$('.component-package-vendor').addClass('hidden');
					break;
				default:
					console.log("nothing");
				break;
			}
		});

		// component type stuff
		$('.component_detail_type > .btn-default').click(function _packagedByClicked() {
			var destination_label,
				i = $(this).data('i');

			if ($(this).data('type') === 'supplier') {
				// show vendor fields
				$('.vendor-fields[data-i="' + i + '"]').removeClass('hidden');

				// hide package supplier field if booked through is direct
				if ($('.btn.btn-default.btn-radio.active[data-type="direct"][data-i="' + i + '"]').length === 1) {
					$('.component-packaged-by.component-package-vendor[data-i="' + i + '"]').addClass('hidden');
				}

				// hide custom component google fields
				$('.fb-places-destination[data-i="' + i + '"]').addClass('hidden');
				$('.fb-places[data-i="' + i + '"]').addClass('hidden');
			} else {
				// hide vendor fields
				$('.vendor-fields[data-i="' + i + '"]').addClass('hidden');

				// show custom component google fields
				$('.fb-places-destination[data-i="' + i + '"]').removeClass('hidden');

				// reset component type
				$('.component-type[data-i="' + i + '"]').val('');
				$('.component-type[data-i="' + i + '"]').trigger('change');

				Adzuki.Typeahead(
					'.google-destination[data-i="' + i + '"]',
					'/Searches/googleLocationSearch',
					function select(item, $self, typeahead) {
						if (item.id) {
							loadGooglePlaceTypeAhead(item, i);
						}

						if (item.city_id) {
							destination_label = item.city_name;

							if (item.city_state_name) {
								destination_label += ', ' + item.city_state_name;
							}

							$('#fitbuilder-destination_search-' + (i - 1)).val(destination_label);
							$('#fitbuilder-destination_search-' + (i - 1)).prop('disabled', true);
							$('#fitbuilder-destination_id-' + (i - 1)).val('cities_' + item.city_id);
							$('.reset-destination[data-i="' + i + '"]').removeClass('hidden');
						}
					},
					null,
					null,
					null,
					false
				);
			}
		});

		$('.packaged_by > .btn-default').click(function _packagedByClicked() {
			var index = $(this).data('i'),
				$component_type_select;

			if ($(this).data('type') === 'supplier') {
				$('.component-package-vendor[data-i="' + index + '"]').removeClass('hidden');
			} else {
				$('.component-package-vendor[data-i="' + index + '"]').addClass('hidden');

				// need to reset the options in the select
				Adzuki.Ajax.get('/FitBuilders/componentTypes/')
				.then(function _adjustSelections(response) {
					$component_type_select = $('.component-type[data-i="' + index + '"]');
					$component_type_select.empty();
					$component_type_select.append($('<option>').text('Please Select').attr('value', 'request'));

					$.each(response, function _iterateTypes(_index, element) {
						$component_type_select.append($('<option>').text(element).attr('value', _index));
					});
				});
			}
		});

		$('.package-vendor-select').change(function _adjustPackagedComponent() {
			var vendor_id = $(this).val(),
				i         = $(this).data('i'),
				$component_type_select;

			if (vendor_id.length > 0) {
				Adzuki.Ajax.get('/FitBuilders/packageSupportedTypes/' + vendor_id)
				.then(function _adjustSelections(response) {
					$component_type_select = $('.component-type[data-i="' + i + '"]');
					$component_type_select.empty();
					$component_type_select.append($('<option>').text('Please Select').attr('value', 'request'));

					$.each(response, function _iterateTypes(index, element) {
						$component_type_select.append($('<option>').text(element).attr('value', index));
					});
				});
			}
		});

		$('#fitbuilder-primary_vendor_id').change(function _changePrimaryVendor() {
			var vendor_id = $(this).val(),
				$component_type_select;

			if (vendor_id.length > 0) {
				Adzuki.Ajax.get('/FitBuilders/packageSupportedTypes/' + vendor_id)
				.then(function _adjustSelections(response) {
					$component_type_select = $('.component-type');
					$component_type_select.empty();
					$component_type_select.append($('<option>').text('Please Select').attr('value', 'request'));

					$.each(response, function _iterateTypes(index, element) {
						$component_type_select.append($('<option>').text(element).attr('value', index));
					});
				});
			}
		});

		Adzuki.Typeahead(
			'#fitbuilder-client_search',
			'/Clients/search',
			function select(item) {
				$('#fitbuilder-client_id').val(item.id);
				$('#fitbuilder-client_search').val(item.full_name);
				$('#fitbuilder-client_search').prop('disabled', true);

				$('.reset-client').removeClass('hidden');
			},
			function template(item) {
				var html;

				if (item.result_name) {
					html = item.result_name;
				} else {
					html = item.full_name;
				}

				html += item.age;

				return html;
			}
		);

		$('#reset-client-link').click(function _resetClient(e) {
			e.preventDefault();

			$('#fitbuilder-client_id').val('');
			$('#fitbuilder-client_search').val('');
			$('#fitbuilder-client_search').prop('disabled', false);
			$('.reset-client').addClass('hidden');
		});

		$('.reset-destination-link').click(function _resetDestination(e) {
			var num = $(this).data('i'),
				i   = num - 1;

			e.preventDefault();

			$('#fitbuilder-destination_search-' + i).val('');
			$('#fitbuilder-destination_search-' + i).prop('disabled', false);
			$('#fitbuilder-destination_id-' + i).val('');

			$('.reset-destination[data-i="' + num + '"]').addClass('hidden');
		});

		$('#reset-primary-vendor-link').click(function _resetPrimaryVendor(e) {
			e.preventDefault();

			$('#fitbuilder-primary_vendor_id').val('');
			$('#fitbuilder-vendor_search').val('');
			$('#fitbuilder-vendor_search').prop('disabled', false);
			$('.reset-primary-vendor').addClass('hidden');
		});

		$('.fit-builder-library-select').click(function _showImagePicker(e) {
			e.preventDefault();

			showImagePicker();
		});

		$('.remove-image').click(function _removeLibraryImage(e) {
			e.preventDefault();

			$('#fitbuilder-library_image').val('');
			$('#fitbuilder-remove_picture').val('1');
			$('.selected-image').attr('src', '');

			$('.selected-image-remove').addClass('hidden');
		});

		$('.reset-component-vendor').click(function _clearDetailLinks(e) {
			var num = $(this).data('i');

			e.preventDefault();

			$('.component_vendors[data-i="' + num + '"]').val('');
			$('.component_vendors[data-i="' + num + '"]').prop('disabled', false);
			$('.reset-typeahead[data-i="' + num + '"]').addClass('hidden');
			$('.hide-vendor[data-i="' + num + '"]').addClass('hidden');
			$('.fit-builder-detail-item[data-i="' + num + '"]').html('');

			$('#fitbuilder-vendor_id-' + (num-1)).val('');
			$('#fitbuilder-title-' + (num -1)).val('');

			Adzuki.Editor('#fitbuilder-description-' + (num - 1), {
				init_instance_callback: function onEditorInit(_editor) {
					_editor.setContent('');
					$('#fitbuilder-description-' + (num - 1)).val('');
				},
			});

			loadVendorTypeAhead(num);

			if ($(this).val() === '') {
				$('.add-details-container[data-i="' + num + '"]').addClass('hidden');
				$('#fit-builder-details-type-' + num).val('');
			}
		});

		$('.fit-builder-detail-link').click(function _fitBuilderLink(e) {
			var num        = $(this).data('i'),
				type       = $('#fit-builder-details-type-' + num).val(),
				form_name  = type.charAt(0).toUpperCase() + type.slice(1),
				vendor_id  = $('#fitbuilder-vendor_id-' + (num -1)).val(),
				start_date = $('#start-date-' + num + '_hidden').val(),
				start_time = $('#start-date-' + num + '-time_hidden').val(),
				end_date   = $('#end-date-' + num + '_hidden').val(),
				end_time   = $('#end-date-' + num + '-time_hidden').val();

			e.preventDefault();

			if (start_time !== '') {
				start_date = start_date + ' ' + start_time;
			}

			if (end_time !== '') {
				end_date = end_date + ' ' + end_time;
			}

			$modal.addClass('wide');
			$modal.find('.modal-title').text('Add details');
			$modal.find('.modal-body').text('Loading form...');

			// might want to not do this for certain types
			// create an array with heights by type?
			$modal.find('.modal-body').css('min-height', '675px');

			Adzuki.Ajax.get('/FitBuilders/addComponentDetails/' + type + '/' + num + '/' + vendor_id + '/' + start_date + '/' + end_date)
			.then(function _showAddComponentDetails(html) {
				$modal.find('.modal-body').html(html);

				Adzuki.Form.initAjaxForm('FitBuilder' + form_name);

				if (type === 'excursion') {
					Adzuki.Form.initAjaxForm('FitBuilderViator');
				}

				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		});

		$modal.on('click', '.fit-builder-cancel', function _cancelModal(e) {
			e.preventDefault();

			$('.btn-default[data-dismiss="modal"]').trigger('click');
		});

		$('.remove-details').click(function _removeDetails(e) {
			var num = $(this).data('i');

			e.preventDefault();

			// $('.add-details-container[data-i="' + num + '"]').addClass('hidden');
			$('#fit-builder-details-type-message-' + num).addClass('hidden');
			$('.fit-builder-detail-link[data-i="' + num + '"]').removeClass('hidden');

			// eslint-disable-next-line no-unused-expressions
			$('#saved_details_' + num).val('');
		});

		// get sailings
		$('.fit-builder-detail-item').on('change', '.fit-builder-ships', function _getSailings() {
			var keyParts,
				num               = $(this).data('i'),
				sailing_selection = $('.fit-builder-sailings[data-i="' + num + '"]'),
				url               = '/CruiseSearch/getSailings/' + $(this).val();

			sailing_selection.empty();
			sailing_selection.append($('<option>').text('Choose Sailing').attr('value', ''));

			Adzuki.Ajax.get(url).then(function success(data) {
				$.each(data, function parseSailings(key, value) {
					keyParts = key.split("|");

					sailing_selection.append($('<option>').text(value).attr('value', keyParts[1]));
				});
			});

			sailing_selection.focus();
		});

		$('.fit-builder-detail-item').on('change', '.fit-builder-sailings', function _getSailings() {
			var num = $(this).data('i');

			Adzuki.Ajax.get('/FitBuilders/sailing/' + $(this).val()).then(function success(data) {
				$('#start-date-' + num).val(data.start_date);
				$('#end-date-' + num).val(data.end_date);
				$('#start-date-' + num).data("DateTimePicker").date(data.start_date);
				$('#end-date-' + num).data("DateTimePicker").date(data.end_date);
				$('#fitbuilder-title-' + (num - 1)).val(data.title);

				Adzuki.Editor('#fitbuilder-description-' + (num - 1), {
					init_instance_callback: function onEditorInit(_editor) {
						_editor.setContent(data.description);
						$('#fitbuilder-description-' + (num - 1)).val(data.description);
					},
				});

				if (data.subregion_id) {
					$('#fitbuilder-destination_search-' + (num-1)).val(data.subregion);
					$('#fitbuilder-destination_search-' + (num-1)).prop('disabled', true);
					$('#fitbuilder-destination_id-' + (num-1)).val('subregions_' + data.subregion_id);
					$('.reset-destination[data-i="' + num + '"]').removeClass('hidden');
				}
			});
		});

		$('.fit-builder-detail-item').on('change', '.fitbuilder-resorts', function _geResortDetails() {
			var num         = $(this).data('i'),
				property_id = $(this).val(),
				hotel_address;

			Adzuki.Ajax.get('/AllInclusiveProperties/getPropertyDetails/' + property_id).then(function success(property) {
				$('.fitbuilderlodging-image_url[data-i="' + num + '"]').val(property.image);
				$('.fit-builder-hotel-image[data-i="' + num + '"]').html('<img style="margin: 10px 0px 10px 0px; max-width: 300px" src="' + Adzuki.base_uri + '/' + property.image + '">');

				$('#fitbuilder-title-' + (num - 1)).val(property.name);

				Adzuki.Editor('#fitbuilder-description-' + (num - 1), {
					init_instance_callback: function onEditorInit(_editor) {
						_editor.setContent(property.long_description);
						$('#fitbuilder-description-' + (num - 1)).val(property.long_description);
					},
				});

				hotel_address = property.address + '|';
				hotel_address += property.latitude + '|';
				hotel_address += property.longitude;

				$('.fitbuilderlodging-address[data-i="' + num + '"]').val(hotel_address);

				if (property.country_id) {
					$('#fitbuilder-destination_search-' + (num-1)).val(property.country);
					$('#fitbuilder-destination_search-' + (num-1)).prop('disabled', true);
					$('#fitbuilder-destination_id-' + (num-1)).val('countries_' + property.country_id);
					$('.reset-destination[data-i="' + num + '"]').removeClass('hidden');
				}
			});
		});

		$('.fit-builder-detail-item').on('click', '#reset-viator-destination-link', function _resetVendor(e) {
			var num = $(this).data('i');

			e.preventDefault();

			$('.fitbuilderviator-destination_id[data-i="' + num + '"]').val('');
			$('.fitbuilderviator-autocomplete[data-i="' + num + '"]').val('');
			$('.fitbuilderviator-destination_id[data-i="' + num + '"]').val('');
			$('.fitbuilderviator-autocomplete[data-i="' + num + '"]').prop('disabled', false);
			$('.reset-viator-destination[data-i="' + num + '"]').addClass('hidden');
			$('.viator-selection[data-i="' + num +'"]').removeClass('hidden');

			$('.fitbuilderviator-excursion-autocomplete[data-i="' + num + '"]').val('');
			$('.fitbuilderexcursion-product_code[data-i="' + num + '"]').val('');
			$('.fitbuilderviator-excursion-autocomplete[data-i="' + num + '"]').prop('disabled', false);
			$('.viator-selection[data-i="' + num + '"]').addClass('hidden');
			$('.fit-builder-viator-image[data-i="' + num + '"]').html('');

			loadViatorDestinationSearch(num);
		});

		$('.fit-builder-detail-item').on('click', '#reset-viator-product-link', function _resetViatorProduct(e) {
			var num = $(this).data('i');

			e.preventDefault();

			$('.reset-viator-product[data-i="' + num + '"]').addClass('hidden');
			$('.fitbuilderviator-excursion-autocomplete[data-i="' + num + '"]').val('');
			$('.fitbuilderexcursion-product_code[data-i="' + num + '"]').val('');
			$('.fitbuilderviator-excursion-autocomplete[data-i="' + num + '"]').prop('disabled', false);
			$('.fit-builder-viator-image[data-i="' + num + '"]').html('');
		});

		$('.fit-builder-detail-item').on('click', '#reset-hotel-link', function _resetHotel(e) {
			var num = $(this).data('i');

			e.preventDefault();

			$('.fitbuilderlodging-autocomplete[data-i="' + num + '"]').val('');
			$('.fitbuilderlodging-image_url[data-i="' + num + '"]').val('');
			$('.fitbuilderlodging-giata_id[data-i="' + num + '"]').val('');
			$('.fitbuilderlodging-address[data-i="' + num + '"]').val('');
			$('.fitbuilderlodging-autocomplete[data-i="' + num + '"]').prop('disabled', false);
			$('.reset-hotel[data-i="' + num + '"]').addClass('hidden');

			$('.fit-builder-hotel-image[data-i="' + num + '"]').html('');
		});

		$('.add_start').on('dp.change', function dateChange(e) {
			var num            = $(this).data('i'),
				iterator       = num - 1,
				val            = $(this).val(),
				val_date       = moment(val, "MM/DD/YYYY").add(1, 'days'),
				component_type = $('#fitbuilder-component_type-' + iterator).val();

			// only update the end date if the date field was changed
			if (val.length === 10) {
				// determine if we should set end date to same as start date or the next day
				if ($no_add_components.includes(component_type) === true || component_type === null) {
					$('.add_end[data-i="' + num + '"]').data('DateTimePicker').date(val);
				} else {
					$('.add_end[data-i="' + num + '"]').data('DateTimePicker').date(val_date);
				}
			}
		});

		$('.fit-builder-descriptions').click(function _showDescriptions(e) {
			e.preventDefault();

			$modal.addClass('wide');
			$modal.find('.modal-title').text('Booked Through');
			$modal.find('.modal-body').text('Loading...');

			Adzuki.Ajax.get('/FitBuilders/descriptions/')
			.then(function _showFBDescriptions(html) {
				$modal.find('.modal-body').html(html);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		});

		$('.reset-google-destination-link').click(function _resetGoogleDestination(e) {
			var i = $(this).data('i');

			e.preventDefault();

			$('.google-destination[data-i="' + i + '"]').val('');
			$('.google-destination[data-i="' + i + '"]').prop('disabled', false);

			$('#fitbuilder-google_location-' + (i-1)).prop('disabled', true);

			$('.reset-google-destination[data-i="' + i + '"]').addClass('hidden');

			$('.fb-places[data-i="' + i + '"]').addClass('hidden');
			$('#reset-google-location-link-' + i).trigger('click');

			$('#fitbuilder-google_location-' + (i -1)).val('');
			$('.fit-builder-google-image[data-i="' + i + '"]').html('');
			$('.reset-google-location[data-i="' + i + '"]').addClass('hidden');

			Adzuki.Editor('#fitbuilder-description-' + (i - 1), {
				init_instance_callback: function onEditorInit(_editor) {
					_editor.setContent('');
					$('#fitbuilder-description-' + (i - 1)).val('');
				},
			});

			$('#fitbuilder-title-' + (i-1)).val('');
		});

		$('.reset-google-location-link').click(function _resetGoogleLocation(e) {
			var i = $(this).data('i');

			e.preventDefault();

			$('#fitbuilder-google_location-' + (i -1)).val('');
			$('#fitbuilder-google_location-' + (i -1)).prop('disabled', false);
			$('.fit-builder-google-image[data-i="' + i + '"]').html('');
			$('#fitbuilder-fit_builder_google_component_image-' + (i -1)).val('');
			$('.reset-google-location[data-i="' + i + '"]').addClass('hidden');

			Adzuki.Editor('#fitbuilder-description-' + (i - 1), {
				init_instance_callback: function onEditorInit(_editor) {
					_editor.setContent('');
					$('#fitbuilder-description-' + (i - 1)).val('');
				},
			});

			$('#fitbuilder-title-' + (i-1)).val('');
		});

		$('#fake-submit-button').on('click', function _triggerSave() {
			$('.form-loader').css('visibility', 'visible');
			$('#submit-button').trigger('click');
		});

		// eslint-disable-next-line vars-on-top
		var num = 0;

		for (incrementor=1;incrementor<=$('#fitbuilder-number_components').val();incrementor++) {
			num = incrementor;

			loadVendorTypeAhead(num);
			loadDestinationTypeAhead(num);

			if ($('.component-type[data-i="' + num + '"]').val() !== "") {
				switch ($('.component-type[data-i="' + num + '"]').val()) {
					case 'excursion':
						if ($('.fitbuilderviator-destination_id[data-i="'+ num + '"]').length > 0) {
							loadViatorDestinationSearch(num);
							// loadViatorProductTypeAhead(num, $('.fitbuilderviator-destination_id[data-i="' + num + '"]').val());
						}
						break;
					case 'lodging':
						if ($('.fitbuilderlodging-autocomplete[data-i="' + num + '"]').length > 0) {
							loadHotelTypeAhead(num);
						}
					break;
					default:
						// nothing
					break;
				}
			}
		}

		$(document).on('click', '.btn-radio', function _switchProperty() {
			var i = $(this).data('i'); 
			
			if ($(this).data('type') === 'inclusive') {
				$('.fit-builder-hotel-image[data-i="' + i + '"]').html('');
				$('#reset-hotel-link[data-i="' + i + '"]').click();
				$('.all-inclusive-' + i).removeClass('hidden');
				$('.regular-properties-' + i).addClass('hidden');

				Adzuki.Editor('#fitbuilder-description-' + (i - 1), {
					init_instance_callback: function onEditorInit(_editor) {
						_editor.setContent('');
						$('#fitbuilder-description-' + (i - 1)).val('');
					},
				});
			} else {
				$('.fit-builder-hotel-image[data-i="' + i + '"]').html('');
				$('[name="form_component_data[FitBuilder][hotel][' + i + ']"]').prop('selectedIndex', 0);
				$('.all-inclusive-' + i).addClass('hidden');
				$('.regular-properties-' + i).removeClass('hidden');

				Adzuki.Editor('#fitbuilder-description-' + (i - 1), {
					init_instance_callback: function onEditorInit(_editor) {
						_editor.setContent('');
						$('#fitbuilder-description-' + (i - 1)).val('');
					},
				});
			}
		});
	};

	// ---- DEDICATED FUNCTION ---- //

	function handleCruise(item, num)
	{
		Adzuki.Ajax.get('/FitBuilders/ships/' + item.id + '/' + num)
		.then(function _showCruiseFields(html) {
			$('.fit-builder-detail-item[data-i="' + num +'"]').html(html);
		});
	}

	function handleLodging(item, num)
	{
		var hotel_template,
			property_template,
			start_time,
			end_time;

		start_time = moment().hour(15).minute(0).second(0);
		end_time   = moment().hour(11).minute(0).second(0);

		$('#start-date-' + num + '-time').data("DateTimePicker").date(start_time);
		$('#end-date-' + num + '-time').data("DateTimePicker").date(end_time);

		Adzuki.Ajax.get('/AllInclusiveProperties/getProperties/' + item.id).then(function success(properties) {
			var sorted_properties = Adzuki.Sort.alphabeticValue(properties);

			// if we can get all-inclusive properties for the lodging vendor, do it
			if (sorted_properties.length > 0) {
				property_template = ''
					+ '<div class="form-group property-type">'
						+ '<label class="col-sm-3 control-label">Property Type</label>'
						+ '<div class="col-sm-9">'
							+ '<div class="radio-group packaged_by" data-toggle="buttons">'
								+ '<label class="btn btn-default btn-radio active" data-type="inclusive" data-i="' + num + '">'
								+ '<input type="radio" class="radio-inline property_type" value="inclusive" name="form_component_data[FitBuilder][property_type][' + num + ']" id="fitbuilder-property_type-' + num + '">'
									+ 'All-Inclusive Property'
								+ '</label>&nbsp;'
								+ '<label class="btn btn-default btn-radio" data-type="regular" data-i="' + num + '">'
								+ '<input type="radio" class="radio-inline property_type" value="regular" name="form_component_data[FitBuilder][property_type][' + num + ']" id="fitbuilder-property_type-' + num + '">'
									+ 'Regular Property'
								+ '</label>'
							+ '</div>'
						+ '</div>'
					+ '</div>'
					+ '<div class="form-group hotel-select all-inclusive-' + num + '">'
						+ '<label class="control-label col-sm-3">All-Inclusive Resort</label>'
						+ '<div class="col-sm-9">'
							+ '<input type="hidden" name="form_component_data[FitBuilder][hotel_address][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-address" value="">'
							+ '<input type="hidden" name="form_component_data[FitBuilder][image_url][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-image_url" value="">'
							+ '<select name="form_component_data[FitBuilder][inclusive_hotel][' + num + ']" data-i="' + num + '" class="form-control fitbuilder-resorts">'
							+ '</select>'
							+ '<div class="fit-builder-hotel-image" data-i="' + num + '"></div>'
						+ '</div>'
					+ '</div>';

					$('.fit-builder-detail-item[data-i="' + num +'"]').html(property_template);
					$('.fitbuilder-resorts[data-i="' + num + '"]').empty();
					$('.fitbuilder-resorts[data-i="' + num + '"]').append($('<option>').text('Please Select').attr('value', ''));

					$.each(sorted_properties, function loadProperty(i, property) {
						$('.fitbuilder-resorts[data-i="' + num + '"]').append($('<option>').text(property.value).attr('value', property.key));
					});

					hotel_template = ''
					+ '<div class="form-group hotel-select regular-properties-' + num + ' hidden">'
						+ '<label class="control-label col-sm-3">Hotel Name</label>'
						+ '<div class="col-sm-9">'
							+ '<input type="hidden" name="form_component_data[FitBuilder][hotel_address][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-address" value="">'
							+ '<input type="hidden" name="form_component_data[FitBuilder][giata_id][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-giata_id" value="">'
							+ '<input type="hidden" name="form_component_data[FitBuilder][image_url][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-image_url" value="">'
							+ '<input type="text" autocomplete="off" name="form_component_data[FitBuilder][hotel][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-autocomplete" value="">'
							+ '<span class="reset-hotel hidden" data-i="' + num + '">'
								+ '<a href="#" id="reset-hotel-link" data-i="' + num + '">Reset Hotel</a>&nbsp;&nbsp;&nbsp;'
							+ '</span>'
							+ '<div class="fit-builder-hotel-image" data-i="' + num + '"></div>'
						+ '</div>'
					+ '</div>';
	
					$('.fit-builder-detail-item[data-i="' + num +'"]').append(hotel_template);
	
					loadHotelTypeAhead(num);
			} else { // otherwise, use hotel engine to get the data
				hotel_template = ''
				+ '<div class="form-group hotel-select">'
					+ '<label class="control-label col-sm-3">Hotel Name</label>'
					+ '<div class="col-sm-9">'
						+ '<input type="hidden" name="form_component_data[FitBuilder][hotel_address][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-address" value="">'
						+ '<input type="hidden" name="form_component_data[FitBuilder][giata_id][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-giata_id" value="">'
						+ '<input type="hidden" name="form_component_data[FitBuilder][image_url][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-image_url" value="">'
						+ '<input type="text" autocomplete="off" name="form_component_data[FitBuilder][hotel][' + num + ']" data-i="' + num + '" class="form-control fitbuilderlodging-autocomplete" value="">'
						+ '<span class="reset-hotel hidden" data-i="' + num + '">'
							+ '<a href="#" id="reset-hotel-link" data-i="' + num + '">Reset Hotel</a>&nbsp;&nbsp;&nbsp;'
						+ '</span>'
						+ '<div class="fit-builder-hotel-image" data-i="' + num + '"></div>'
					+ '</div>'
				+ '</div>';

				$('.fit-builder-detail-item[data-i="' + num +'"]').html(hotel_template);

				loadHotelTypeAhead(num);
			}
		});
	}

	function handleViator(item, num)
	{
		var viator_template = ''
		+ '<div class="form-group hotel-select">'
			+ '<label class="control-label col-sm-3">Viator Destination</label>'
			+ '<div class="col-sm-9">'
				+ '<input type="hidden" name="form_component_data[FitBuilder][viator_destination_id][' + num + ']" data-i="' + num + '" class="form-control fitbuilderviator-destination_id" value="">'
				+ '<input type="text" autocomplete="off" name="form_component_data[FitBuilder][hotel][' + num + ']" data-i="' + num + '" class="form-control fitbuilderviator-autocomplete" value="">'
				+ '<span class="reset-viator-destination  data-i="' + num + '" hidden">'
					+ '<a href="#" id="reset-viator-destination-link" data-i="' + num + '">Reset Viator Destination</a>&nbsp;&nbsp;&nbsp;'
				+ '</span>'
			+ '</div>'
		+ '</div>'
		+ '<div class="form-group hidden viator-selection" data-i="' + num + '">'
			+ '<label class="control-label col-sm-3">Viator Excursion</label>'
			+ '<div class="col-sm-9">'
				+ '<input type="hidden" name="form_component_data[FitBuilder][viator_image_url][' + num + ']" data-i="' + num + '" class="form-control fitbuilderexcursion-image_url" value="">'	
				+ '<input type="hidden" name="form_component_data[FitBuilder][viator_product_code][' + num + ']" data-i="' + num + '" class="form-control fitbuilderexcursion-product_code" value="">'
				+ '<input type="hidden" name="form_component_data[FitBuilder][viator_product_duration][' + num + ']" data-i="' + num + '" class="form-control fitbuilderexcursion-product_duration" value="">'
				+ '<input type="text" autocomplete="off" name="form_component_data[FitBuilder][viator_excursion][' + num + ']" data-i="' + num + '" class="form-control fitbuilderviator-excursion-autocomplete" value="">'
				+ '<span class="reset-viator-product hidden" data-i="' + num + '">'
					+ '<a href="#" id="reset-viator-product-link" data-i="' + num + '">Reset Viator Excursion</a>&nbsp;&nbsp;&nbsp;'
				+ '</span>'
				+ '<div class="fit-builder-viator-image" data-i="' + num + '"></div>'
			+ '</div>'
		+ '</div>';

		$('.fit-builder-detail-item[data-i="' + num +'"]').html(viator_template);

		loadViatorDestinationSearch(num);
	}

	function loadDestinationTypeAhead(num)
	{
		var iterator = num - 1;

		Adzuki.Typeahead(
			'#fitbuilder-destination_search-' + iterator,
			'/Searches/destination/all/',
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);
				$('#fitbuilder-destination_id-' + iterator).val(item.id);

				$('#fitbuilder-destination_search-' + iterator).val(item.name);
				$('#fitbuilder-destination_search-' + iterator).prop('disabled', true);
				$('.reset-destination[data-i="' + num + '"]').removeClass('hidden');
			}
		);
	}

	function loadHotelTypeAhead(num)
	{
		var hotel_address,
			description;

		Adzuki.Typeahead(
			'.fitbuilderlodging-autocomplete[data-i="' + num + '"]',
			'/Searches/hotelSearch/',
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);

				$('.fitbuilderlodging-autocomplete[data-i="' + num + '"]').prop('disabled', true);
				$('.reset-hotel[data-i="' + num + '"]').removeClass('hidden');

				if (item.giata_id) {
					Adzuki.Ajax.get(Adzuki.base_uri + '/HotelEngine/hotelMetaData/' + item.giata_id)
					.then(function success(response) {
						$('#fitbuilder-title-' + (num - 1)).val(response.name);
						$('.fitbuilderlodging-giata_id[data-i="' + num + '"]').val(item.giata_id);

						if (response.metadata.property.description_rooms) {
							description = response.metadata.property.description_rooms;

							Adzuki.Editor('#fitbuilder-description-' + (num - 1), {
								init_instance_callback: function onEditorInit(_editor) {
									_editor.setContent(description);
									$('#fitbuilder-description-' + (num - 1)).val(description);
								},
							});
						}

						if (response.street_address_1) {
							hotel_address = response.street_address_1 + '|';
							hotel_address += response.street_address_2 + '|';
							hotel_address += response.city + '|';
							hotel_address += response.state_prov + '|';
							hotel_address += response.postal_code + '|';
							hotel_address += response.country_code + '|';
							hotel_address += response.latitude + '|';
							hotel_address += response.longitude;

							$('.fitbuilderlodging-address[data-i="' + num + '"]').val(hotel_address);
						}

						if (response.metadata.images) {
							response.metadata.images.forEach(function _getImages(image, i) {
								if (image.hero_image === '1') {
									$('.fitbuilderlodging-image_url[data-i="' + num + '"]').val(image.large);
									$('.fit-builder-hotel-image[data-i="' + num + '"]').html('<img style="margin: 10px 0px 10px 0px" src="' + image.medium + '">');
								}
							});
						}

						if (response.city_id) {
							$('#fitbuilder-destination_search-' + (num-1)).val(response.city_name + ' ' + response.state_prov);
							$('#fitbuilder-destination_search-' + (num-1)).prop('disabled', true);
							$('#fitbuilder-destination_id-' + (num-1)).val('cities_' + response.city_id);
							$('.reset-destination[data-i="' + num + '"]').removeClass('hidden');
						}
					});
				}
			},
			function template(item) {
				var html;

				if (item.city) {
					html = item.name + ' (' + item.city + ', ' + item.country_code + ')';
				} else if (item.street_address_1) {
					html = item.name + ' (' + item.street_address_1 + ')';
				} else {
					html = item.name;
				}
				return html;
			}
		);
	}

	function loadGooglePlaceTypeAhead(item, index)
	{
		var description,
			image,
			i = index - 1;

		$('#fitbuilder-google_destination-' + i).prop('disabled', true);
		$('#fitbuilder-google_location-' + i).prop('disabled', false);

		$('.fb-places[data-i="' + index + '"]').removeClass('hidden');
		$('.reset-google-destination[data-i="' + index + '"]').removeClass('hidden');

		Adzuki.Typeahead(
			'#fitbuilder-google_location-' + i,
			'/Searches/googlePlaceLookup/' + item.id,
			function select(item, $self, typeahead) {
				$('#fitbuilder-google_location-' + i).prop('disabled', true);

				if (item.id) {
					description = '';

					Adzuki.Ajax.get(Adzuki.base_uri + '/Searches/googlePlaceDetails/' + item.id)
					.then(function success(response) {
						$('#fitbuilder-title-' + i).val(response.name);

						if (response.images.length > 0) {
							image = Adzuki.base_uri + '/Searches/googleImageConvert/' + response.images[0].photo_reference;

							$('.reset-google-location[data-i="' + index + '"]').removeClass('hidden');
							$('#fitbuilder-fit_builder_google_component_image-' + i).val(image);
							$('.fit-builder-google-image[data-i="' + index + '"]').html('<img style="margin: 10px 0px 10px 0px" src="' + image + '">');
						}

						// set the component description to the website
						if (response.website) {
							description += '<p>Website: <a href="' + response.website + '" target="_blank">' + response.website + '</a></p>';
						}

						// and address
						if (response.html_address) {
							description += '<p>Address: ' + response.html_address + '</p>';
						}

						Adzuki.Editor('#fitbuilder-description-' + (i), {
							init_instance_callback: function onEditorInit(_editor) {
								_editor.setContent(description);
								$('#fitbuilder-description-' + (i)).val(description);
							},
						});
					});
				}
			},
			null,
			null,
			null,
			false
		);
	}

	function loadVendorTypeAhead(num)
	{
		var iterator       = num - 1,
			component_type = $('#fitbuilder-component_type-' + iterator).val();

		Adzuki.Typeahead(
			'#fitbuilder-vendor_search-' + iterator,
			'/Vendors/searchVendorByType/' + component_type + '/',
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);
				$('#fitbuilder-vendor_id-' + iterator).val(item.id);
				$('.hide-vendor[data-i="' + num + '"]').removeClass('hidden');

				// eslint-disable-next-line no-lonely-if
				if ($('#fitbuilder-component_type-' + iterator).val() === item.primary_component_type) {
					// eslint-disable-next-line no-lonely-if
					if ($('#fitbuilder-component_type-' + iterator).val() === 'package') {
						$('.add-details-container[data-i="' + num + '"]').addClass('hidden');
						$('#fit-builder-details-type-' + num).val('');
					} else {
						$('#fit-builder-details-type-' + num).val(item.primary_component_type);

						// based on the component type bring in a unique UI just below the vendor selection
						switch (item.primary_component_type) {
							case 'lodging':
								$('.fit-builder-detail-item[data-i="' + num +'"]').removeClass('hidden');
								handleLodging(item, num);
							break;
							case 'cruise':
								$('.fit-builder-detail-item[data-i="' + num +'"]').removeClass('hidden');
								handleCruise(item, num);
							break;
							case 'excursion':
								if (item.name_without_type.indexOf('Viator') !== -1) {
									$('.fit-builder-detail-item[data-i="' + num +'"]').removeClass('hidden');
									handleViator(item, num);
								}
							break;
							default:
								$('.add-details-container[data-i="' + num + '"]').removeClass('hidden');
								$('.fit-builder-detail-link[data-i="' + num + '"]').removeClass('hidden');
							break;
						}
					}
				} else {
					$('.reset-component-vendor[data-i="' + num + '"]').trigger('click');
					Adzuki.StatusMessage('error', 'Sorry, the vendor you chose does not support the component type you selected above.');
					$('.component-type[data-i="' + num + '"]').val('');
				}
			},
			null,
			null,
			null,
			true
		);

		$('#fitbuilder-vendor_search-' + iterator).focus();
	}

	function loadViatorDestinationSearch(num)
	{
		Adzuki.Typeahead(
			'.fitbuilderviator-autocomplete[data-i="' + num + '"]',
			'/Viator/destinationSearch',
			function selectDestination(item) {
				$('.fitbuilderviator-autocomplete[data-i="' + num + '"]').val(item.name);
				$('.fitbuilderviator-destination_id[data-i="' + num + '"]').val(item.destination_id);

				$('.fitbuilderviator-autocomplete[data-i="' + num + '"]').prop('disabled', true);
				$('.reset-viator-destination[data-i="' + num +'"]').removeClass('hidden');
				$('.viator-selection[data-i="' + num +'"]').removeClass('hidden');

				loadViatorProductTypeAhead(num, item.destination_id);
			},
			null,
			null,
			null,
			true
		);
	}

	function loadViatorProductTypeAhead(num, viator_destination_id)
	{
		var product_lookup_url = '/Searches/viator/' + viator_destination_id + '/';

		Adzuki.Typeahead(
			'.fitbuilderviator-excursion-autocomplete[data-i="' + num + '"]',
			product_lookup_url,
			function selectProduct(item) {
				$('.fitbuilderviator-excursion-autocomplete[data-i="' + num + '"]').val(item.name + ' (' + item.id + ')');
				$('.fitbuilderexcursion-product_code[data-i="' + num + '"]').val(item.id);
				$('.fitbuilderexcursion-image_url[data-i="' + num + '"]').val(item.thumbnail_hi_res_url);
				$('.fit-builder-viator-image[data-i="' + num + '"]').html('<img style="margin: 10px 0px 10px 0px" src="' + item.thumbnail_url + '">');
				$('.fitbuilderviator-excursion-autocomplete[data-i="' + num + '"]').prop('disabled', true);
				$('.reset-viator-product[data-i="' + num + '"]').removeClass('hidden');
				$('#fitbuilder-title-' + (num - 1)).val(item.name);
				$('.fitbuilderexcursion-product_duration[data-i="' + num + '"]').val(item.duration);

				Adzuki.Editor('#fitbuilder-description-' + (num - 1), {
					init_instance_callback: function onEditorInit(_editor) {
						_editor.setContent(item.short_description);
						$('#fitbuilder-description-' + (num - 1)).val(item.short_description);
					},
				});

				if (item.price) {
					$('#fitbuilder-quoted_price-' + (num-1)).val(item.price);
				}

				if (item.city_id) {
					$('#fitbuilder-destination_search-' + (num-1)).val(item.city_name);
					$('#fitbuilder-destination_search-' + (num-1)).prop('disabled', true);
					$('#fitbuilder-destination_id-' + (num-1)).val('cities_' + item.city_id);
					$('.reset-destination[data-i="' + num + '"]').removeClass('hidden');
				}
			},
			function template(item) {
				var html;

				html = item.name + ' (' + item.id + ')';

				return html;
			},
			null,
			null,
			true
		);
	}

	function showImagePicker()
	{
		$('.image-library-preview').attr('src', '');

		$modal.addClass('wide');
		$modal.find('.modal-title').text('Image Library');
		$modal.find('.modal-body').text('Loading image library...');

		Adzuki.Ajax.get('/Images/imagePicker')
		.then(function _showImagePicker(html) {
			$modal.find('.modal-body').html(html);

			Adzuki.Form.initAjaxForm('ImageSearch');
		});

		$modal.on('click', '.image-picker .select-image', function selectImage() {
			var $image = $(this).parents('.image-container').find('img'),
				$src = $image.attr('src');

			$('#fitbuilder-picture').val('');
			$('#fitbuilder-library_image').val($src);
			$('#fitbuilder-remove_picture').val('');
			$('.selected-image').attr('src', $src);

			$('.selected-image-remove').removeClass('hidden');

			$modal.modal('hide');
		});

		$modal.on('click', '.add-button-btn', function addImageButtonPressed() {
			Adzuki.CustomConfirm({
				title  : 'Add image?',
				content: 'Adding images must be done through the Image section of the web program. Clicking \'Ok\' will take you there now. Would you like to go? Please note any unsaved work may be lost.',
				confirm: function confirm() {
					document.location = Adzuki.webprogram_url + Adzuki.base_uri + '/Images/add/';
				}
			});
		});

		$modal.on('hidden.bs.modal', function _restoreModal() {
			$modal.removeClass('wide').off('hidden.bs.modal')
				  .off('click', '.image-picker .select-image');
		}).modal('show');
	}
}(jQuery, window.Adzuki || {}));
